import { ChartColumn } from "lucide-react";
import { useNavigate } from "react-router";
import { SalesGateway } from "./SaleRecord.ts";
import { salesStatisticsPathFor } from "./salesStatisticsPath.ts";

export function SalesStatisticsButton({ gateway }: { gateway?: SalesGateway }) {
  const navigate = useNavigate();
  return (
    <button
      type="button"
      onClick={() => navigate(salesStatisticsPathFor(gateway))}
      title="Statistiche vendite"
      className="flex items-center gap-1.5 px-3 py-2 rounded-lg border border-gray-300 bg-white text-gray-700 text-sm font-medium hover:bg-gray-50 shrink-0"
    >
      <ChartColumn className="w-4 h-4" />
      Statistiche
    </button>
  );
}
